import { defineStore } from "pinia";
import { useAuthStore } from "@switchsystems/coactive-vue-lib";

const API_NAME = "rota";
const API_VERSION = "/v1";

const CACHE_TIME_MINUTES = 60 * 4;
const CACHE_SOFT_RECHECK_MINUTES = 15;
const MAX_PAGE_SIZE = 250;

export const useRotaUsersStore = defineStore(
  "rotausers",
  () => {
    const getMyRotaUser = async function () {
      const authStore = useAuthStore();
      return this.$api.get(
        API_NAME,
        `${API_VERSION}/rota-users/${authStore.user.id}`,
      );
    };

    const getRotaUsersForUserSelection = async function () {
      const myInit = {
        queryStringParameters: {
          pageSize: MAX_PAGE_SIZE,
          sort: JSON.stringify({ initials: 1 }),
        },
      };

      return this.$api
        .getAllPages(API_NAME, `${API_VERSION}/rota-users`, myInit)
        .then((response) => {
          if (response === false) {
            return [];
          }
          if (response?._embedded["rota-users"] === undefined) {
            throw new Error(
              "pinia client: error fetching rota users (no embedded rota-users found)",
            );
          }
          return response._embedded["rota-users"];
        });
    };

    /* used for cache busting */
    const hasNewerRotaUsers = (context, cachedItems) => {
      const largestDateModified = cachedItems.reduce((acc, cur) => {
        if (cur.dateModified > acc) {
          return cur.dateModified;
        }
        return acc;
      }, new Date(0));

      const myInit = {
        queryStringParameters: {
          page: 1,
          pageSize: 1,
          filter: JSON.stringify([
            {
              subject: "dateModified",
              comparison: "gt",
              value: largestDateModified,
            },
          ]),
        },
      };

      return context.$api
        .get(API_NAME, `${API_VERSION}/rota-users`, myInit)
        .then((response) => {
          if (response === false) {
            return false;
          }
          if (response?.count > 0) {
            return true;
          }
          return false;
        });
    };

    return {
      getRotaUsersForUserSelection,
      hasNewerRotaUsers,
      getMyRotaUser,
    };
  },
  {
    localStorageCache: [
      {
        function: "getRotaUsersForUserSelection",
        expiryCheckFunction: "hasNewerRotaUsers",
        options: {
          cacheTimeMinutes: CACHE_TIME_MINUTES,
          expiryCheckTimeMinutes: CACHE_SOFT_RECHECK_MINUTES,
        },
      },
      {
        function: "getMyRotaUser",
        options: {
          cacheTimeMinutes: CACHE_TIME_MINUTES,
        },
      },
    ],
  },
);
